<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <div style="display: flex;">
        <div style="width:58%" class="box">
          <p class="title">关于一起推(分销)</p><p>
          一起推(分销)功能开放，是为了解放推广人员双手，秉着平台用户合作共赢、共同致富的理念而开放的。</p><p class="title">
          一起推(分销)利润的产生与分配</p><p>
          针对分销用户,只要邀请用户入驻、消费，在入驻资源产生利润或者消费中产生利润,均可获得一定比例的利润分配,利润分配比例最高可达百分之90。(例如：用户A邀请用户B上传资源，用户B的资源在平台上被其他用户消费产生利润,利润会根据资源百分比发放给用户A。用户A邀请用户c在平台推广消费，产生利润会根据百分比发放给用户A。假若用户BC均为用户A邀请进来，用户A获得两者利润分配，最高可达百分之90，如创造100利润，用户A最高可获得90的利润分配。)</p><p class="title">
          —起推(分销)时效及要求</p><p>
          只要受邀人进来,则分销人员对其产生的所有利润分配均永久有效。申请成为一起推分销人员,即代表分销人员会严格遵守平台规则规章,接受平台因市场监管需求、用户要求和运营成本所需而调整规章制度及分配比例。</p><p style="color:red;margin-top:10px">
          一次邀请,终生受益。只要用户的资源或者推广产生了收益,无论你在一不在河享受到一起推带来的红利!真正的解放双手,还在等什么?一起加入一起推去享受你的诗和远方吧!</p><p>
        </p>
                  <div>
            <el-checkbox v-model="checked">我已阅读《智汇众盈传媒平台所有协议》</el-checkbox>
            <el-button @click="onCopy">复制我的推广链接</el-button>
          </div></div>
        <div style="width:40%;margin-left:10px" class="box">
          <p class="title">推广小技巧 </p><p>根据用户的不同,编辑不同的推广标语。</p><p>
          针对资源入驻人员，可从无差价、无任何中介入住费、注册上传即可等待订单获取收益</p><p>
          等方向编辑推广标语</p><p>
          针对客户群体,具体取决于客户群体类型，例如网络媒体推广、抖音营销、微信营销、朋友圈营销，平台直接合作，无中间商差价。为企业节约成本等等方面去编辑推广标语。</p><p>
          后续平台会通过平台网站、抖音、微信微信公众号等渠道做推广技巧介绍，欢迎广大用户互动。</p><p>
          后续平台微信微信公众号会更新相关推广技巧,届时可关注微信微信公众号查看。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadTop from "../components/HeadTop";
import myAxios from "../myAxios";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      checked:false,
      username: localStorage.getItem("username"),
      userPhone: localStorage.getItem("phone"),
    };
  },
  components: {
    HeadTop,
  },
  created() {},
  methods: {
    onCopy(e) {
      if(!this.checked){
            this.$notify.error({
              title: "提示",
              message: "请先同意《智汇众盈传媒平台所有协议》",
            });
        return
      }
      let text = `http://pt.zhzymedia.cn/#/register?intuser=${this.username}`;
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        this.$alert("复制成功", "提示", {
          confirmButtonText: "确定",
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {});
      clipboard.onClick(e);
    },
  },
};
</script>
<style lang="less" scoped>
@import "../style/mixin";
.table_container {
  padding: 20px;
}
.title{
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
}
.box{
  border: 1px solid #999;
  padding: 10px;
}
</style>
